import { render, staticRenderFns } from "./topbar-base.vue?vue&type=template&id=25fcbd84"
import script from "./topbar-base.vue?vue&type=script&lang=js"
export * from "./topbar-base.vue?vue&type=script&lang=js"
import style0 from "./topbar-base.vue?vue&type=style&index=0&id=25fcbd84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports